// @ts-strict-ignore
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import withStyles from "isomorphic-style-loader/withStyles";

import classes from "./style.scss";

interface Props {
	links: {
		label: string;
		to: string;
		disabled?: boolean;
	}[];
	title: string;
	children: JSX.Element;
}

const Breadcrumbs : React.FC<Props> = ({ links, title, children }) => {
	return (
		<div className={classes.breadcrumbsContainer}>
			<div className={classes.linksContainer}>
				{links.map((link, index) => {
					return (
						<Fragment key={`${index}-${link.label}`}>
							{index !== 0
								? (
									<span className={classes.linkSeparator}>/</span>
								)
								: null
							}

							{index === links.length - 1 || link.disabled
								? (
									<span className={classes.link}>
										{link.label}
									</span>
								)
								: (
									<Link
										to={link.to}
										className={classes.link}
									>
										{link.label}
									</Link>
								)
							}
						</Fragment>
					);
				})}
			</div>

			<div className={`${classes.titleButtonsRow} ${children?.length > 2 ? classes.titleButtonsRowColumn : ""}`}>
				<h1>{title}</h1>
				
				<div className={classes.buttonsSection}>
					{children}
				</div>
			</div>
		</div>
	);
};

export default withStyles(classes)(Breadcrumbs);
